import { render, staticRenderFns } from "./PoliticaAtrasos.vue?vue&type=template&id=4e98b76a&"
import script from "./PoliticaAtrasos.vue?vue&type=script&lang=js&"
export * from "./PoliticaAtrasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports